import type { ReactNode } from 'react';
import { TabLayout } from '../TabLayout';
import { ClonePageActionButtons } from './ClonePageActionButtons';
import { ClonePageBreadcrumbs } from './ClonePageBreadcrumbs';
import { ClonePageTitle } from './ClonePageTitle';

interface DemoTabLayoutProps {
  children: ReactNode;
}

export const ClonePageTabLayout = ({ children }: DemoTabLayoutProps) => {
  return (
    <TabLayout
      entity="record"
      title={<ClonePageTitle />}
      breadcrumbs={<ClonePageBreadcrumbs />}
      actionButtons={<ClonePageActionButtons />}
    >
      {children}
    </TabLayout>
  );
};
